import { createPubSub } from '@/helpers/pubSub';

export const variablesBus = createPubSub();

// events
export const ON_VARIABLE_EDIT = 'OnVariableEdit';
export const ON_VARIABLE_DELETE = 'OnVariableDelete';
